import React from 'react';
import { TooltipData } from '../types';
import './TooltipPopup.css';

interface TooltipPopupProps {
    tooltip: TooltipData;
    offset?: number;
}

const TOOLTIP_MAX_WIDTH = 320;

export const TooltipPopup: React.FC<TooltipPopupProps> = ({ tooltip, offset = 15 }) => {
    if (!tooltip.visible) return null;

    // Se non c'è spazio a destra, il popup si apre a sinistra del puntatore (senza la punta della nuvoletta)
    const flip = tooltip.x + offset + TOOLTIP_MAX_WIDTH > window.scrollX + window.innerWidth;
    const left = flip ? Math.max(window.scrollX + 4, tooltip.x - offset - TOOLTIP_MAX_WIDTH) : tooltip.x + offset;

    return (
        <div
            role="tooltip"
            className={`absolute z-50 p-3 text-sm bg-white border border-gray-200 rounded-lg gantt-shadow-tooltip gantt-tooltip-bubble${flip ? ' gantt-tooltip-flipped' : ''}`}
            style={{ top: tooltip.y + offset, left, pointerEvents: 'none' }}
        >
            {tooltip.content}
        </div>
    );
};
